import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const LOGIN_PAGE_LOGO_SIZE = '350px';

const useStyles = makeStyles((theme: Theme) => ({
  formWrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.background.paper,
  },
  form: {
    width: '30%',
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
    boxSizing: 'border-box',
    '@media screen and (max-width: 800px)': {
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      padding: '20px',
    },
  },
  link: {
    cursor: 'pointer',
  },
  externalLoginContainer: {
    display: 'flex',
    gap: '10px',
  },
  logo: {
    maxWidth: LOGIN_PAGE_LOGO_SIZE,
    maxHeight: LOGIN_PAGE_LOGO_SIZE,
    margin: '0px auto',
    objectFit: 'contain',
    width: '100%',
    height: '100%',
  }
}));

export default useStyles;
